module.exports = __webpack_public_path__ + "img/onboarding_3.afc0dfbb.png";